<template>
  <v-text-field
    v-model="icn"
    :error-messages="icnErrors"
    label="ICN Abbreviation"
    clearable
    required
    @input="$v.icn.$touch()"
    @blur="$v.icn.$touch()"
    @keyup="emitIcnAbbreviation"
  />
</template>

<script>
import { mapActions } from 'vuex';
import { required, maxLength, minLength } from 'vuelidate/lib/validators';

export default {
  data: () => ({
    rawIcn: '',
  }),
  computed: {
    icn: {
      get() {
        return this.rawIcn.toUpperCase();
      },
      set(val) {
        this.rawIcn = val.toUpperCase();
      },
    },
    icnErrors() {
      const errors = [];

      if (!this.$v.icn.$dirty) {
        return errors;
      }

      if (!this.$v.icn.maxLength) {
        errors.push('ICN abbreviation must be 4 characters long');
      }

      if (!this.$v.icn.required) {
        errors.push('ICN abbreviation is required');
      }

      if (!this.$v.icn.minLength) {
        errors.push('ICN abbreviation must be exactly 4 characters long');
      }

      if (!this.$v.icn.isAvailable) {
        errors.push('ICN abbreviation already in use');
      }

      if (!this.$v.icn.containsVowel) {
        errors.push('ICN abbreviation must contain a vowel');
      }

      return errors;
    },
  },
  validations: {
    icn: {
      required,
      maxLength: maxLength(4),
      minLength: minLength(4),
      async isAvailable(value) {
        if (value === '') {
          return true;
        }
        const isValid = await this.validateIcn();
        return Boolean(!isValid);
      },
      async containsVowel(value) {
        if (value === '') {
          return true;
        }

        return Boolean(this.icnContainsVowel());
      },
    },
  },
  methods: {
    ...mapActions('apiClient', ['get']),
    icnContainsVowel() {
      const matches = this.icn.match(/[aeiou]/ig);
      return matches;
    },
    async validateIcn() {
      if (!this.icn || this.icn.length < 4) {
        return true;
      }

      let valid = true;

      await this.get({ url: '/clients/checkIcn', params: { icn: this.icn } }).then(
        (response) => {
          valid = response.data.valid;
        },
        (error) => {
          console.log(error);
          return true;
        },
      );

      return valid;
    },
    emitIcnAbbreviation() {
      this.$emit('icnSet', this.icn.toUpperCase());
    },
  },
};
</script>
